import { SubmissionScope } from '../types';

const SubmissionScopes: { [key in SubmissionScope]: SubmissionScope } = {
    MainSectionOnly: 'MainSectionOnly',
    SectionLevel: 'SectionLevel'
} as const;

export default SubmissionScopes;
